var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bars"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"flex xs12"},[_c('horizontal-bars')],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"flex xs12"},[_c('circle-bars')],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"flex xs12"},[_c('colorful-bars')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }